module.exports = __webpack_public_path__ + "img/integral-item.7e5f3d0d.png";